export const AVON_BRAZIL_INTEGRATION_CLASS = 'AvonBrazilCustom';
